import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs';
import { Document } from 'src/app/shared/models/uba/profileConfiguration/model';
import { TermsOfUseState, TermsOfUseStore } from './terms-of-use.store';

@Injectable({
  providedIn: 'root',
})
export class TermsOfUseQuery extends QueryEntity<TermsOfUseState> {
  protected store: TermsOfUseStore;

  constructor() {
    const store = inject(TermsOfUseStore);

    super(store);

    this.store = store;
  }

  public selectActiveWhenLoaded(): Observable<Document> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectActive())
    );
  }
}
